const home = {
  findOutIfYoureDatingAPrickIn20Questions:
    'Find out if you’re dating a Prick in 20 questions.',
  increaseYourOdds:
    'Increase your odds of ﬁnding a healthy, lasting relationship.',
  introduction: `<p>Welcome to Prick Predictor, a Herculean <strong>humanitarian effort</strong> designed to pinpoint problematic partners and discover those irreconcilable differences before they’ve done too much damage. We’re on a mission to save the world from Pricks.</p>`,
  reviewQuote: 'My results finally confirmed I was dealing with a Prick.',
  reviewName: 'Ashley',
  takeTheSurvey: 'Take the survey',
};

export default home;



// WEBPACK FOOTER //
// ./src/locales/home.js